import { useEffect, useState } from 'react';

/** Tailwindの`lg`と同じ境界。片方だけ変えると表示が二重になるため定数で揃える。 */
const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

function matchesDesktop(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
}

/**
 * `lg`以上の画面かを購読する。
 * CSSのbreakpointだけでは切り替えられない「同じ内容をdesktopは常設paneで、
 * mobileはmodalで出す」ケースに使う。matchMedia非対応環境ではmobile扱いにする。
 * @returns lg以上ならtrue
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(matchesDesktop);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (typeof window.matchMedia !== 'function') return;
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const handleChange = (event: MediaQueryListEvent): void =>
      setIsDesktop(event.matches);
    // mount前に幅が変わっていた場合へ追従する。
    setIsDesktop(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isDesktop;
}
